import { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";

import { APP_URL } from "../../../../../Utils/AppConstance";
import { genericFetchData } from "../../../../../Services/Service";

import AgreementData from "../../../../../Components/Pages/Agreement/AgreementData";
import AgreementUpload from "../../../../../Components/Pages/Agreement/AgreementUpload";
import AgreementTable from "../../../../../Components/Pages/Agreement/AgreementTable";
import useHospitalAdd from "../../../Hospital/useHospitalAdd";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../../../../../Storage/Datastore";
import ToastSnackbar from "../../../../../Components/ToastSnackbar/ToastSnackbar";
import { parseErrorMessage } from "../../../../../Utils/helper";

function AgreementDoctor({
  id,
  setIsReadOnly,
  isReadOnly,
  showApproval,
  setshowApproval,
}) {
  const navigate = useNavigate();
  const userRole = getUserRole();
  const [showTable, setShowTable] = useState(false);
  const [showPreview, setShowPreview] = useState(true);
  const [open, setOpen] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [tableData, setTableData] = useState(false);
  // const [isReadOnly, setIsReadOnly] = useState(false);
  const [agreementData, setAgreementData] = useState({
    agreementStartDate: "",
    agreementEndDate: "",
    professionalId: id,
    hospitalDoc: [],
    document: [],
    image: [],
    hospitalImage: [],
    documentIds: [],
  });

  const { ...state } = useHospitalAdd();

  const handleToast = (error) => {
    setOpen(true);
    if (error) {
      setToastMessage("Error");
    } else {
      setToastMessage("Success");
    }
  };

  const saveAgreementDetails = async () => {
    try {
      const formData = new FormData();

      if (agreementData.hospitalDoc.length > 0) {
        formData.append("document", agreementData.hospitalDoc[0]);
      }

      formData.append(
        "agreementStartDate",
        agreementData.agreementStartDate ||
        tableData.agreementResponse?.agreementStartDate
      );
      formData.append(
        "agreementEndDate",
        agreementData.agreementEndDate ||
        tableData.agreementResponse?.agreementEndDate
      );
      formData.append("professionalId", agreementData.professionalId);

      const url = `${APP_URL}/professional/agreement/save`;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setShowPreview(false);
        getAgreementData();
        handleToast(false);
        setshowApproval();
        const responseData = await response.json();
        return responseData;
      } else {
        const text = await response.json();
        handleToast(true);
        setToastMessage(parseErrorMessage(text.errorMessage));
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      // handleToast(true);
      // setToastMessage("Error, failed to save agreement details");
      console.log("Failed to save agreement details:", error);
    }
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return; //
    }
    setOpen(false);
  };

  const getAgreementData = async () => {
    try {
      const response = await genericFetchData(
        `/professional/agreementData?professionalId=${agreementData.professionalId}&isDownload=false`,
        "GET"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      setTableData(responseData);
    } catch (error) {
      console.log(error);
    }
  };

  const sendDoctorApproval = async () => {
    try {
      const response = await fetch(
        `${APP_URL}/professional/agreement/approval/send?professionalId=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log("Success");
      setTimeout(() => {
        navigate("/mySpace");
      }, 1000);
      handleToast(false);
      setToastMessage("Approval send successfully");
    } catch (error) {
      handleToast(true);
      setToastMessage("Error sending approval");
      console.error("Error sending doctor approval:", error);
    }
  };

  const getSampleAgreementFile = async () => {
    try {
      const response = await genericFetchData(
        `/professional/agreementData?professionalId=${id}&isDownload=true`,
        "GET"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "agreement.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAgreementData();
  }, []);

  useEffect(() => {
    tableData?.agreementResponse?.agreementEndDate
      ? setIsReadOnly(true)
      : setIsReadOnly(false);
    setShowTable(true);
  }, [tableData]);

  useEffect(() => { }, [isReadOnly]);

  return (
    <Grid margin={2}>
      <Typography
        sx={{ color: "#20BB9E", fontSize: 16, fontWeight: 500, paddingY: 4 }}
      >
        Agreements
      </Typography>
      <AgreementData
        setAgreementData={setAgreementData}
        agreementData={agreementData}
        isReadOnly={isReadOnly}
        readonlyData={tableData}
        doctor
        isLive={state.isLive}
      />

      {!state.isLive && (
        <AgreementUpload
          setAgreementData={setAgreementData}
          agreementData={agreementData}
          handleSave={saveAgreementDetails}
          showPreview={showPreview}
          setShowTable={setShowTable}
          getAgreementData={getAgreementData}
          getSampleAgreementFile={getSampleAgreementFile}
          isReadOnly={isReadOnly}
        />
      )}

      <Grid paddingY={5}>
        <AgreementTable showTable={showTable} tableDataa={tableData} />
      </Grid>
      {/* {userRole === "FINANCE_EXECUTIVE" && ( */}
      {!showApproval && (
        <Grid textAlign={"end"}>
          {!state.isLive && (
            <Box
              width={"155px"}
              fontSize={"13px"}
              border={"#414851"}
              sx={{
                textTransform: "capitalize",
                color: "#414851",
                bgcolor: "#17DFBA",
                fontWeight: 500,
                alignSelf: "flex-end",
                fontFamily: "poppins",
              }}
              height={"46px"}
              component={Button}
              onClick={() => sendDoctorApproval()}
            >
              Send for Approval
            </Box>
          )}
        </Grid>
      )}
      <ToastSnackbar
        handleOpen={open}
        message={toastMessage}
        onClose={handleCloseToast}
      />
    </Grid>
  );
}

export default AgreementDoctor;
